import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_175 implements Validator {

	public static id = 'CTRL_175';
	private message = 'error.ctr_175';


	public LOG: LogService = new LogService(CTRL_175);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_175.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];

				const lieuLivraisonNumCtrl = form.controls[ctrl.value.rgCtrls.lieuLivraisonNum]?.value;
				const lieuLivraisonNomCtrl = form.controls[ctrl.value.rgCtrls.lieuLivraisonNom]?.value;
				const lieuLivraisonTypeVoieCtrl = form.controls[ctrl.value.rgCtrls.lieuLivraisonTypeVoie]?.value;
				
				let lieuLivraison = lieuLivraisonNumCtrl?.length + lieuLivraisonNomCtrl?.length + lieuLivraisonTypeVoieCtrl?.length;

				if(!isNaN(lieuLivraison)) {
					if (lieuLivraison < 5 ) {
						// placer le message d'erreur
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
					} else {
						form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
					}
				}
			}
		}
	}
}
